import React, {useState, useRef, useEffect} from 'react'
// import { useDispatch } from 'react-redux'
import validatorWrapper from '../utils/validatorWrapper'
import { formatNumber } from './utils'

export const useInput = (name, value, onChangeCB, status, validationMethods, ref) => {
  // const myRef = useRef(null)
  let errors = []
  let validationMsg = null

  // function handleChange(e) {
  //   e.preventDefault()
  //   e.stopPropagation()
  //   const myValue = e.target.value
  //   errors = validatorWrapper.validate(validationMethods, myValue)
  //
  //   // console.log('--errors--', errors)
  //
  //   onChangeCB(name, myValue, errors[0])
  // }

  function handleBlur(e) {
    e.preventDefault()
    e.stopPropagation()

    // Todo: don't need to call handleChange() to trigger calculation because
    //       handleChange has been called per character input
    // In case we change the doCalculation invoke logic, then we may need to call
    // handleChange(e)

    ref.current.classList.remove('-focused')
  }

  function handleFocus(e) {
    e.preventDefault()
    e.stopPropagation()

    ref.current.classList.add('-focused')
  }

  return {
    ref: ref,
    value: formatNumber(value),
    // onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    error: status
  }
}

export const useFormInput = (name, value, onChangeCB, status, validationMethods, ref) => {
  let errors = []

  function handleChange(e) {
    e.preventDefault()
    e.stopPropagation()

    const myValue = e.target.value
    errors = validatorWrapper.validate(validationMethods, myValue)
    onChangeCB(name, myValue, errors[0])
  }

  function handleBlur(e) {
    e.preventDefault()
    e.stopPropagation()

    const myValue = e.target.value
    errors = validatorWrapper.validate(validationMethods, myValue)
    onChangeCB(name, myValue, errors[0])

    ref.current.classList.remove('-focused')
  }

  function handleFocus(e) {
    e.preventDefault()
    e.stopPropagation()

    ref.current.classList.add('-focused')
  }

  return {
    ref: ref,
    value: value,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    error: status
  }
}

// 'rc-select' DEPRECETED
// export function useRCSelect(name, value, options, onChangeCB) {
//   const myRef = useRef(null)
//
//   function handleChange(selectedValue) {
//     onChangeCB(name, selectedValue)
//     console.log('--handleChange--', selectedValue)
//   }
//
//   function handleBlur(selectedValue) {
//     handleChange(selectedValue)
//     console.log('--handleBlur--', selectedValue)
//     myRef.current.inputRef.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove('-focused')
//   }
//
//   function handleFocus() {
//     console.log('--handleFocus--')
//     myRef.current.inputRef.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add('-focused')
//   }
//
//   return {
//     ref: myRef,
//     value: value,
//     options: options,
//     onChange: handleChange,
//     onBlur: handleBlur,
//     onFocus: handleFocus
//   }
// }

export const useDropdown = (name, value, options, onChangeCB, ref) => {
  // const dispatch = useDispatch()
  const [status, setStatus] = useState({shown: false, isOpen: false})

  let selectedOption = []
  if (value && options.length > 0) {
    selectedOption.push(options.find((x) => {return x.value === value}))
  } else {
     selectedOption.push(options[0])
  }

  function handleChange(myOption) {
    if (value != myOption[0].value) {
      onChangeCB(name, myOption[0].value)
    }
  }

  function handleDropdownOpen() {
    // console.log('--handleDropdownOpen')
    ref.current.classList.add('-focused')
    setStatus({isOpen: true})
  }

  function handleDropdownClose() {
    // console.log('--handleDropdownClose')
    ref.current.classList.remove('-focused')
    setStatus({isOpen: false})
    //TODO Move focus to next element
  }

  const handleKeyDownFn = ({ event, state, props, methods, setState }) => {
    const { cursor } = state
    const escape = event.key === 'Escape'
    const enter = event.key === 'Enter'
    const arrowUp = event.key === 'ArrowUp'
    const arrowDown = event.key === 'ArrowDown'
    const backspace = event.key === 'Backspace'
    const tab = event.key === 'Tab' && !event.shiftKey
    const shiftTab = event.shiftKey && event.key === 'Tab'

    if (enter && cursor === null) {
      // setStatus({ shown: true })
      return setState({
        cursor: 0
      })
    }

    if (arrowUp || arrowDown || shiftTab || tab) {
      event.preventDefault();
    }

    if (enter || tab || shiftTab) {
      const currentItem = methods.searchResults()[cursor]
      if (currentItem && !currentItem.disabled) {
        if (props.create && valueExistInSelected(state.search, state.values, props)) {
          return null
        }
        methods.addItem(currentItem)
      }
    }

    if (arrowDown && methods.searchResults().length === cursor) {
      setState({
        cursor: 0
      })
    }

    if (arrowUp && cursor === 0) {
      setState({
        cursor: methods.searchResults().length - 1
      })
    }

    if (backspace && props.multi && props.backspaceDelete && getInputSize() === 0) {
      setState({
        values: state.values.slice(0, -1)
      })
    }
  }

  const getInputSize = (state, props) => {
    if (state.search) {
      return state.search.length;
    }

    if (state.values.length > 0) {
      return props.addPlaceholder.length;
    }

    return props.placeholder.length;
  }

  return {
    ref: ref,
    isOpen: status.isOpen,
    shown: status.shown,
    options: options,
    values: selectedOption,
    onChange: handleChange,
    onDropdownOpen: handleDropdownOpen,
    onDropdownClose: handleDropdownClose,
    handleKeyDownFn: handleKeyDownFn,
  }
}

const valueExistInSelected = (value, values, props) =>
  !!values.find((val) => getByPath(val, props['valueField']) === value);

// react-select DEPRECATED
// export function useSelect(name, value, options, onChangeCB) {
//   const myRef = useRef(null)
//
//   let selectedOption = null
//   if (value && options.length > 0) {
//     selectedOption = options.find((x) => {return x.value === value})
//   } else {
//      selectedOption = options[0]
//   }
//
//   function handleChange(option) {
//     onChangeCB(name, option.value)
//   }
//
//   function handleBlur(e) {
//     e.preventDefault()
//     e.stopPropagation()
//     handleChange(e)
//
//     e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.remove('-focused')
//   }
//
//   function handleFocus(e) {
//     e.preventDefault()
//     e.stopPropagation()
//
//     e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.classList.add('-focused')
//   }
//
//   return {
//     ref: myRef,
//     value: selectedOption,
//     options: options,
//     onChange: handleChange,
//     onBlur: handleBlur,
//     onFocus: handleFocus
//   }
// }
//
export const useMultiSelect = (name, value, options, onChangeCB, ref) => {
  const [status, setStatus] = useState({shown: false, isOpen: false})

  let selectedOptions = []
  if (value.length>0 && options.length > 0) {
    selectedOptions.push(value.split(',').map(x => {return (options.find((y) => { return y.value === x }))
    }))
  }

  const handleChange = (selectedOptions) => {
    let output = ""

    for (let i = 0; i < selectedOptions.length; i++) {
      if(!output.includes(selectedOptions[i].value)) {
        output = output + ((i === 0) ? '' : ',') + selectedOptions[i].value
      }
    }
    onChangeCB(name, output)
  }

  function handleDropdownOpen() {
    // console.log('--handleDropdownOpen')
    ref.current.classList.add('-focused')
    setStatus({isOpen: true})
  }

  function handleDropdownClose() {
    // console.log('--handleDropdownClose')
    ref.current.classList.remove('-focused')
    setStatus({isOpen: false})
  }

  const handleKeyDownFn = ({ event, state, props, methods, setState }) => {
    const { cursor } = state
    const escape = event.key === 'Escape'
    const enter = event.key === 'Enter'
    const arrowUp = event.key === 'ArrowUp'
    const arrowDown = event.key === 'ArrowDown'
    const backspace = event.key === 'Backspace'
    const tab = event.key === 'Tab' && !event.shiftKey
    const shiftTab = event.shiftKey && event.key === 'Tab'

    if (enter && cursor === null) {
      // setStatus({ shown: true })
      return setState({
        cursor: 0
      })
    }

    if (arrowUp || arrowDown || shiftTab || tab) {
      event.preventDefault();
    }

    if (enter || tab || shiftTab) {
      const currentItem = methods.searchResults()[cursor]
      if (currentItem && !currentItem.disabled) {
        if (props.create && valueExistInSelected(state.search, state.values, props)) {
          return null
        }
        methods.addItem(currentItem)
      }
    }

    if (arrowDown && methods.searchResults().length === cursor) {
      setState({
        cursor: 0
      })
    }

    if (arrowUp && cursor === 0) {
      setState({
        cursor: methods.searchResults().length - 1
      })
    }

    if (backspace && props.multi && props.backspaceDelete && getInputSize() === 0) {
      setState({
        values: state.values.slice(0, -1)
      })
    }
  }

  const getInputSize = (state, props) => {
    if (state.search) {
      return state.search.length;
    }

    if (state.values.length > 0) {
      return props.addPlaceholder.length;
    }

    return props.placeholder.length;
  }

  return {
    multi: true,
    ref: ref,
    isOpen: status.isOpen,
    // shown: status.shown,
    values: selectedOptions,
    options: options,
    onChange: handleChange,
    onDropdownOpen: handleDropdownOpen,
    onDropdownClose: handleDropdownClose,
    handleKeyDownFn: handleKeyDownFn
  }
}


export const useRadioButton = (name, value, onChangeCB) => {
  const myRef = useRef(null)

  function handleChange(choice) {
    onChangeCB(name, choice)
  }

  return {
    ref: myRef,
    selectedValue: value,
    onChange: handleChange
  }
}

export const useActionButton = (name, onChangeCB, disabled) => {
  // const myRef = useRef(null)

  function handleClick(e) {
    e.preventDefault()
    e.stopPropagation()
    onChangeCB()
  }

  return {
    // ref: myRef,
    onClick: handleClick,
    disabled: disabled
  }
}

export const useCalculateButton = (name) => {
  const myRef = useRef(null)

  return {
    ref: myRef
  }
}

export const useLogicButton = (name, value, onChangeCB) => {
  // const myRef = useRef(null)

  function handleClick(e) {
    e.preventDefault()
    e.stopPropagation()
    onChangeCB(name, !value)
  }

  return {
    // ref: myRef,
    value: value,
    onClick: handleClick
  }
}

export const useTextButton = (name, value, targetValue, onChangeCB, isDisabled) => {
  // const myRef = useRef(null)

  function handleClick(e) {
    e.preventDefault()
    onChangeCB(name, targetValue)
  }

  return {
    // ref: myRef,
    // value: value,
    disabled: isDisabled,
    onClick: handleClick
  }
}

export function useCheckbox(name, value, onChangeCB, ref) {

  function handleChange(e) {
    e.preventDefault()
    onChangeCB(name, !(e.target.checked))
  }

  return {
    checked: !value,
    type: 'checkbox',
    ref: ref,
    onChange: handleChange
  }
}

export function useCheckboxEnhanced(name, value, onChangeCB, ref) {

  function handleChange(e) {
    e.preventDefault()
    onChangeCB(name, e.target.checked)
  }

  return {
    checked: value,
    type: 'checkbox',
    ref: ref,
    onChange: handleChange
  }
}
// 'react-modal' DEPRECATED
// export function useModal(initialValue) {
//   const [value, setValue] = useState(initialValue)
//   const myRef = useRef(null)
//
//   function openModal() {
//     setValue(true)
//   }
//
//   function closeModal() {
//     setValue(false)
//   }
//
//   function handleOnAfterOpenModal() {
//     /* TBD */
//   }
//
//   return ({
//     ref: myRef,
//     value: value,
//     ariaHideApp: false,
//     openModal: openModal,
//     closeModal: closeModal,
//     isOpen: value,
//     shouldCloseOnOverlayClick: true,
//     onAfterOpen: handleOnAfterOpenModal,
//     onRequestClose: closeModal
//   })
// }

export const useBootstrapModal = (initialValue) => {
  const [value, setValue] = useState(initialValue)

  function openModal() {
    setValue(true)
  }

  function closeModal() {
    setValue(false)
  }

  return ({
    value: value,
    openModal: openModal,
    closeModal: closeModal
  })
}

export const useCombinedRefs = (...refs) => {
  const targetRef = useRef()

  useEffect(() => {
    refs.forEach(ref => {
      if (!ref) return

      if (typeof ref === 'function') {
        ref(targetRef.current)
      } else {
        ref.current = targetRef.current
      }
    })
  }, [refs])

  return targetRef
}
